export enum EPermission {
  Read = 1,
  Write = 2,
  Delete = 3,
  Import = 4,
  LockPayroll = 5,
  Export = 6,
}
